<template>
    <div class="flex justify-between items-center pl-3 max-w-40">
        <div class="w-6 h-6 flex justify-center items-center cursor-pointer" @click="prevScheduleMonth()">
            <icon width="9" height="13">
                <IconChevronLeft />
            </icon>
        </div>
        <div class="rounded bg-grayxlight h-[26px] w-24 text-center pt-1 first-letter:uppercase">
            {{ month }}
        </div>
        <div class="w-6 h-6 flex justify-center items-center cursor-pointer" @click="nextScheduleMonth()">
            <icon width="9" height="13">
                <IconChevronRight />
            </icon>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, ref, onMounted } from 'vue'
import IconChevronLeft from '../../ui/icons/IconChevronLeft.vue'
import IconChevronRight from '../../ui/icons/IconChevronRight.vue'
import { useScheduleStore } from '@/stores/scheduleStore'

const store = useScheduleStore()

const emit = defineEmits(['date'])

const date = ref(store.currentScheduleDate)

const month = computed(() => date.value.format('MMMM'))

const nextScheduleMonth = () => {
        date.value = date.value.add(1, 'month')
        emit('date', date)
    }

const prevScheduleMonth = () => {
        date.value = date.value.subtract(1, 'month')
        emit('date', date)
    }

onMounted(() => {
    emit('date', date)
})
</script>
